/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { AidType } from './aid-type.model';


export class DossierCapacity {
    capacityCode?: string; // ecf001
    capacity?: string; // ecf001
    code?: string; // ecf001
    capable?: boolean; // ecf001 => 1 = capable / 0 : incapable
    aid?: string; // ecf001 => 1 = represented / 0 = council
    decisionDate?: string; // ecf001 => date of the decision


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): DossierCapacity {
        if (!data) { return instance; }
        if (data.code != null) {instance.code = data.code; }
        if (data.capable != null) {instance.capable = data.capable; }
        if (data.aid != null) {instance.aid = data.aid; }
        if (data.decisionDate != null) {instance.decisionDate = data.decisionDate; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return DossierCapacity.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: DossierCapacity) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return DossierCapacity.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: DossierCapacity): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
